'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeProductToActivationType = exports.productActivationProducts = undefined;

var _upgradeProductToActi;

var _upgradeProducts = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productActivationProducts = exports.productActivationProducts = [_upgradeProducts.upgradeProducts.CRM, _upgradeProducts.upgradeProducts.CMS, _upgradeProducts.upgradeProducts.SALES_FREE, _upgradeProducts.upgradeProducts.MARKETING_FREE, _upgradeProducts.upgradeProducts.SERVICE_FREE];

var activationTypes = {
  HUBSPOT_SALES: 'HUBSPOT_SALES',
  MARKETING_FREE: 'MARKETING_FREE',
  SERVICE_FREE: 'SERVICE_FREE',
  CMS: 'CMS_FREE',
  CRM: 'CRM'
};

var upgradeProductToActivationType = exports.upgradeProductToActivationType = (_upgradeProductToActi = {}, _defineProperty(_upgradeProductToActi, _upgradeProducts.upgradeProducts.SALES_FREE, activationTypes.HUBSPOT_SALES), _defineProperty(_upgradeProductToActi, _upgradeProducts.upgradeProducts.MARKETING_FREE, activationTypes.MARKETING_FREE), _defineProperty(_upgradeProductToActi, _upgradeProducts.upgradeProducts.CMS, activationTypes.CMS), _defineProperty(_upgradeProductToActi, _upgradeProducts.upgradeProducts.CRM, activationTypes.CRM), _defineProperty(_upgradeProductToActi, _upgradeProducts.upgradeProducts.SERVICE_FREE, activationTypes.SERVICE_FREE), _upgradeProductToActi);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/constants/productActivation.js
// module id = 497
// module chunks = 3 4